import React from 'react';
import { Zap, ShieldCheck } from 'lucide-react';

const EnableBots = ({ onEnable, loading, error, darkMode }) => {
  return (
    <div className={`flex flex-col items-center justify-center p-8 text-center rounded-3xl border backdrop-blur-xl transition-all animate-entry
      ${darkMode 
        ? 'bg-primary/60 border-white/10' 
        : 'bg-white/80 border-slate-200'}
    `}>
      <div className={`w-20 h-20 rounded-3xl flex items-center justify-center mb-6 transform rotate-3 transition-transform hover:rotate-0
        ${darkMode ? 'bg-secondary text-white' : 'bg-secondary text-white'}
      `}>
        <Zap size={32} fill="currentColor" />
      </div>
      
      <h3 className={`text-2xl font-light tracking-tight mb-3 ${darkMode ? 'text-white' : 'text-slate-900'}`}>
        Enable Hicapy Agents
      </h3>
      
      <p className={`mb-8 max-w-xs font-light leading-relaxed ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>
        Activate your personal AI meeting assistants. They can join meetings, take notes, and provide summaries securely.
      </p>
      
      {error && (
        <div className="mb-6 p-4 bg-red-500/10 border border-red-500/20 text-red-500 rounded-2xl text-sm font-medium w-full">
          {error}
        </div>
      )}

      <button
        onClick={onEnable}
        disabled={loading}
        className={`w-full py-4 rounded-2xl font-medium text-lg text-white transform transition-all hover:scale-[1.02] active:scale-[0.98] flex items-center justify-center gap-3
          ${loading ? 'opacity-70 cursor-not-allowed' : ''}
          ${darkMode ? 'bg-secondary hover:bg-secondary/90' : 'bg-secondary hover:bg-secondary/90'}
        `}
      >
        {loading ? (
          <div className="w-6 h-6 border-4 border-white/30 border-t-white rounded-full animate-spin" />
        ) : (
          <Zap size={24} fill="currentColor" />
        )}
        {loading ? 'Activating...' : 'Activate Service'}
      </button>
      
      <div className={`mt-8 flex items-center gap-2 text-xs font-medium uppercase tracking-wider ${darkMode ? 'text-slate-500' : 'text-slate-400'}`}>
        <ShieldCheck size={14} />
        <span>Secure • Private • Encrypted</span>
      </div>
    </div>
  );
};

export default EnableBots;
